import {Utils, StringUtils, Logger} from 'neo-common';
import {omit} from 'lodash';

export class LaunchClientOptions {
    /**
     * @property gameServer - url to game server
     */
    gameServer: string;

    launchServiceParams: Object;

    public static get(): LaunchClientOptions {
        var uri = Utils.getURIQuery();
        var gameServer = uri['gameServer'];
        var customerCode = uri['customerCode'];
        var channelCode = uri['channelCode'];
        var gameCode = uri['gameCode'];
        var operationCode = uri['operationCode'];
        var error = false;

        if (StringUtils.isNullOrEmpty(gameServer)) {
            Logger.errorGroup('LaunchClient', 'Missing query string parameter "gameServer" !');
            error = true;
        }

        if (StringUtils.isNullOrEmpty(customerCode)) {
            Logger.errorGroup('LaunchClient', 'Missing query string parameter "customerCode" !');
            error = true;
        }

        if (StringUtils.isNullOrEmpty(channelCode)) {
            Logger.errorGroup('LaunchClient', 'Missing query string parameter "channelCode" !');
            error = true;
        }

        if (StringUtils.isNullOrEmpty(gameCode)) {
            Logger.errorGroup('LaunchClient', 'Missing query string parameter "gameCode" !');
            error = true;
        }

        if (StringUtils.isNullOrEmpty(operationCode)) {
            Logger.errorGroup('LaunchClient', 'Missing query string parameter "operationCode" !');
            error = true;
        }

        if (error) {
            return null;
        }

        var options = new LaunchClientOptions();
        options.gameServer = gameServer;
        options.launchServiceParams = omit(uri, ['gameServer']);
        return options;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Launch/LaunchClientOptions.ts
 **/